import React, { useEffect } from 'react';
import ImagesMaps from '../../assets/images/maps.png';
import ButtonPrimary from '../misc/ButtonPrimary';
const ModalAddress = (props) => {
  // Overflow hidden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'unset');
  }, []);
  return (
    <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
      <div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content items-center p-6 text-left">
          <div className="flex mb-4">
            <h4>Pilih Alamat Pengantaran</h4>
            <button className="px-2 ml-auto" onClick={props.handdleCloseModal}>
              X
            </button>
          </div>
          <div
            className="flex h-56 mb-4 w-full bg-cover"
            style={{ backgroundImage: `url(${ImagesMaps})` }}
          ></div>
          <ButtonPrimary
            handdleClick={props.handdleClick}
            text="sm"
            addClass={'w-full'}
          >
            Konfirmasi
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default ModalAddress;
